module.exports = __webpack_public_path__ + "img/calendar-wallet-order.f8633652.svg";